import { render, staticRenderFns } from "./WhitelabelFrequentlyAskedQuestions.vue?vue&type=template&id=2a56203d&scoped=true&"
import script from "./WhitelabelFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./WhitelabelFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelFrequentlyAskedQuestions.vue?vue&type=style&index=0&id=2a56203d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56203d",
  null
  
)

export default component.exports